module.exports = __webpack_public_path__ + "img/airvey-jeunesse-logo.a9ed4acf.png";